import { naviPath } from '../../helpers/utils'

import Dashboard from './Dashboard';
import Upgrade from './Upgrade';
import Payment from './Payment';
import PaymentConfirmation from './PaymentConfirmation';
import AccountSettings from './AccountSettings';
import ChangePassword from './ChangePassword';
import Onboarding from './Onboarding';

export const CustomRoutePre = [
  /* Nikita change for routing */
  {
    path: '/onboarding',
    name: 'Onboarding',
    short: 'Onboarding',
    component: Onboarding,
    icon: 'briefcase',
    isPublic: false,
    type: 'Onboarding',
    order: 0,
    inMenu: true,
    menuLabel: 'Home',
    screenId : 1
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    short: 'Dashboard',
    component: Dashboard,
    icon: 'briefcase',
    isPublic: false,
    type: 'Dashboard',
    order: 1,
    inMenu: true,
    menuLabel: 'Home',
    screenId : 1
  },
  {
    path: '/upgrade',
    name: 'Upgrade',
    short: 'Upgrade',
    component: Upgrade,
    icon: 'briefcase',
    isPublic: false,
    type: 'Upgrade',
    order: 2,
    inMenu: true,
    menuLabel: 'Upgrade',
    screenId : 1
  },
  {
    path: '/payment',
    name: 'Payment',
    short: 'Payment',
    component: Payment,
    icon: 'briefcase',
    isPublic: false,
    type: 'Payment',
    order: 3,
    inMenu: false,
    menuLabel: 'Payment',
    screenId : 1
  },
  {
    path: '/payment-confirmation',
    name: 'Payment Confirmation',
    short: 'Payment Confirmation',
    component: PaymentConfirmation,
    icon: 'briefcase',
    isPublic: false,
    type: 'PaymentConfirmation',
    order: 4,
    inMenu: true,
    menuLabel: 'Payment Confirmation',
    screenId : 1
  },
  {
    path: '/account-settings',
    name: 'Account Settings',
    short: 'Account Settings',
    component: AccountSettings,
    icon: 'briefcase',
    isPublic: false,
    type: 'AccountSettings',
    order: 5,
    inMenu: true,
    menuLabel: 'Account Settings',
    screenId : 1
  },
  {
    path: '/change-password',
    name: 'Change Password',
    short: 'Change Password',
    component: ChangePassword,
    icon: 'briefcase',
    isPublic: false,
    type: 'ChangePassword',
    order: 6,
    inMenu: false,
    menuLabel: 'Change assword',
    screenId : 1
  },
]

export const CustomRoutePost = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        short: 'Dashboard',
        component: Dashboard,
        icon: 'briefcase',
        isPublic: false,
        type: 'Dashboard',
        order: 1,
        inMenu: true,
        menuLabel: 'Home',
        screenId : 1
    },    
]

function naviLabel(label, type) {
    if (type === 'MstList') return ((label || {}).MasterLst || {}).label || '';
    else if (type === 'MstRecord') return ((label || {}).MasterRec || {}).label || '';
    else if (type === 'DtlList') return ((label || {}).DetailLst || {}).label || '';
    else if (type === 'DtlRecord') return ((label || {}).DetailRec || {}).label || '';
    else return type;
  }
  
export function getNaviBar(type, mst, dtl, label) {
//    return pagesRoutes
      return []
      .sort((a, b) => a.order - b.order)
      .map((v, i) => {
        return {
          path: naviPath(v.type === 'MstList' ? '_' : mst.subTestId2, '', v.path),
          label: naviLabel(label, v.type),
          type: v.type,
          active: v.type === type,
        }
      });
  }
  


// WEBPACK FOOTER //
// ./src/pages/Custom/index.js